import { RouteObject } from "react-router-dom";
import GisIntegrationLanding from "./components/landing/landing";

export interface GisIntegrationRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: GisIntegrationRoute[];
}

export const ixGisIntegrationRoutes: GisIntegrationRoute[] = [
  {
    path: "/integration-hub/gis-integration",
    element: <GisIntegrationLanding />,
  },
];
